import PropTypes from "prop-types";
import "./CampaignOptionCard.css";

export default function CampaignOptionCard({
  title,
  description,
  selected,
  disabled,
  comingSoon,
  onSelect,
  name,
  value,
}) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      name={name}
      value={value}
      disabled={disabled || comingSoon}
      className={`campaign-option-card${selected ? " campaign-option-card--selected" : ""}${disabled ? " campaign-option-card--disabled" : ""}${comingSoon ? " campaign-option-card--coming-soon" : ""}`}
      onClick={() => {
        if (!disabled && !comingSoon) onSelect(value);
      }}
    >
      <span className="campaign-option-card__title">{title}</span>
      <span className="campaign-option-card__description">{description}</span>
      {comingSoon ? (
        <span className="campaign-option-card__badge">Coming soon</span>
      ) : null}
    </button>
  );
}

CampaignOptionCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  comingSoon: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  name: PropTypes.string,
  value: PropTypes.string.isRequired,
};
